import React from 'react';

import {
  Table,
  createColumnWidths,
  createColumnsWidths,
  createPredefinedColumnWidths,
} from '@qality/common-components/src/atoms/Table';
import CheckboxWithTooltip from '@qality/common-components/src/molecules/CheckboxWithTooltip/CheckboxWithTooltip';

import { useTestCasesInCycleList } from '../TestCaseInCycleListProvider';

type Columns =
  | 'dnd'
  | 'checkbox'
  | 'testType'
  | 'testCase'
  | 'status'
  | 'executionAssignee'
  | 'bugs'
  | 'actions';

const ColumnsWidths = createColumnsWidths<Columns>({
  dnd: createPredefinedColumnWidths('dnd'),
  checkbox: createPredefinedColumnWidths('checkbox'),
  testType: createColumnWidths('48px', '48px'),
  testCase: createColumnWidths('auto', '150px'),
  status: createColumnWidths('150px'),
  executionAssignee: createColumnWidths('300px'),
  bugs: createColumnWidths('300px'),
  actions: createColumnWidths('190px'),
});

export const NUMBER_OF_COLUMNS_FREE = Object.keys(ColumnsWidths).length;

export function TestCasesInCycleTableHeader(): JSX.Element {
  const { testCycle } = useTestCasesInCycleList();

  return (
    <Table.Head>
      <Table.Tr>
        <Table.DndTh widths={ColumnsWidths.dnd} aria-label='Drag and drop' />
        <Table.CheckboxTh
          widths={ColumnsWidths.checkbox}
          aria-label='Bulk select'
        >
          <Table.ContentHelper height='compact' alignItems='center'>
            <CheckboxWithTooltip
              checkboxProps={{
                isDisabled: true,
              }}
              tooltipProps={{
                content: 'Bulk actions are available in QAlity Plus.',
              }}
            />
          </Table.ContentHelper>
        </Table.CheckboxTh>
        <Table.Th widths={ColumnsWidths.testType}>Type</Table.Th>
        <Table.Th widths={ColumnsWidths.testCase}>Test Case</Table.Th>
        <Table.Th widths={ColumnsWidths.status}>Status</Table.Th>
        <Table.Th widths={ColumnsWidths.executionAssignee}>
          Execution Assignee
        </Table.Th>
        <Table.Th widths={ColumnsWidths.bugs}>Bugs</Table.Th>
        {testCycle.canEdit && (
          <Table.Th widths={ColumnsWidths.actions}>Actions</Table.Th>
        )}
      </Table.Tr>
    </Table.Head>
  );
}
